export default __webpack_public_path__ + "static/media/TrendDown.4436bbb0.svg";